import React from "react";
import { useParams } from "react-router-dom";
import { useGetVendorQuotationExcelDetailQuery } from "store/services/vendorQuotationExcelApi";
import VendorQuotationExcelEditScreen from "./VendorQuotationExcelEditScreen";
import VendorQuotationExcelImportEditScreen from "./VendorQuotationExcelImportEditScreen";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

const VendorQuotationExcelEditDispatcher = () => {
    const { id } = useParams();
    const { data, isLoading, error } = useGetVendorQuotationExcelDetailQuery(id);

    if (isLoading) {
        return (
            <BreadcrumbLayout breadcrumbs={[{ title: "Loading..." }]} isBusy />
        );
    }

    if (error) {
        return (
            <BreadcrumbLayout breadcrumbs={[{ title: "Error" }]}>
                <BreadcrumbLayout.Error error={error} />
            </BreadcrumbLayout>
        );
    }

    if (data?.isImported) {
        return <VendorQuotationExcelImportEditScreen />;
    }

    return <VendorQuotationExcelEditScreen />;
};

export default VendorQuotationExcelEditDispatcher;